export function getTimeDifference(matchDate: string): any {
  if (!matchDate) {
    return 'n/a'; // or throw error if you prefer strict handling
  }

  const parsedDate = new Date(matchDate);

  // Check if date is valid
  if (isNaN(parsedDate.getTime())) {
    return 'n/a'; // invalid date string
  }

  const now = Date.now();
  const matchTime = parsedDate.getTime();

  const diff = matchTime - now; // positive = future, negative = past
  if(diff > 0) return diff;
  return 'n/a'
}